// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paper-2JgYC";
var _4 = "root-2Ix7i";
var _5 = "bgFill-330Vv";
var _6 = "content-1H0f2";
var _7 = "mobileDialog__dialog-1C2Yl";
var _8 = "mobileDialog__header-3g1-x";
var _9 = "mobileDialog__title-2B5M5";
var _a = "mobileDialog__footer-kAeSP";
export { _1 as "__esModule", _2 as "mobile", _3 as "paper", _4 as "root", _5 as "bgFill", _6 as "content", _7 as "mobileDialog__dialog", _8 as "mobileDialog__header", _9 as "mobileDialog__title", _a as "mobileDialog__footer" }
export default { "__esModule": _1, "mobile": _2, "paper": _3, "root": _4, "bgFill": _5, "content": _6, "mobileDialog__dialog": _7, "mobileDialog__header": _8, "mobileDialog__title": _9, "mobileDialog__footer": _a }
